import { render } from "./OrderDetailModal.vue?vue&type=template&id=36c2f9be&scoped=true"
import script from "./OrderDetailModal.vue?vue&type=script&lang=js"
export * from "./OrderDetailModal.vue?vue&type=script&lang=js"

import "./OrderDetailModal.vue?vue&type=style&index=0&id=36c2f9be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c2f9be"]])

export default __exports__